import { inviteMember } from '../api/gas';
export default async ({ email, firstName, lastName }, logger) => {
    return inviteMember('invite', { email, firstName, lastName }, logger);
};
